import { useQuery } from '@tanstack/react-query'
import { axiosInstance } from '@/lib/axios'
import { PanelInvoicesResponse } from '../types'

/**
 * Invoices issued through the external Claro payment panel — the billing source
 * of truth for Manual (invoiced) companies. Only relevant when the tenant's
 * billingProvider is Manual; callers gate via `enabled`.
 */
export function useQueryPanelInvoices(
  companyId: string | null | undefined,
  enabled: boolean,
) {
  return useQuery<PanelInvoicesResponse>({
    queryKey: ['subscription.panelInvoices', companyId],
    queryFn: async () => {
      const { data } = await axiosInstance.get(
        `/config-api/${companyId}/subscription/panel-invoices`,
      )
      return data
    },
    enabled: !!companyId && enabled,
    // The backend caches per NIP for 15 min — refetching sooner returns
    // byte-identical data, so match its TTL.
    staleTime: 15 * 60_000,
  })
}
